import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Title from '../Title'
import { ContentWrapper } from '../PageList'

const Intro: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <ContentWrapper>
      <div className="flex flex-col gap-12 md:gap-40 pb-10 md:pb-0">
        <Title text={t.naw.survey.answer.intro.title} />
        <div className="text-lg whitespace-pre-wrap mt-3 text-black">{t.naw.survey.answer.intro.description}</div>
      </div>
    </ContentWrapper>
  )
}

export default Intro
